module.exports = __webpack_public_path__ + "static/img/3_1_1.e5216f01.jpg";